import useRoutesHandler from "@/Hooks/useRouteHandler";
import { ILoginSchema } from "@/Pages/Login/auth.types";
import { getRedirectPathFromAuth } from "@/utility/auth.utils";
import { handleNetworkError } from "@/utility/networkError.utility";
import {
  useGetAuthUserService,
  usePartnerAuthServiceMutations,
} from "@repo/api-services/admin";
import { setAuthorizationHeader } from "@repo/api-services/Axios";

export default function usePartnerLogin() {
  const { navigate } = useRoutesHandler();
  const { authService } = useGetAuthUserService();
  const { loginMutation, logoutMutation } = usePartnerAuthServiceMutations();

  const handlePartnerLogin = async (data: ILoginSchema) => {
    try {
      const response = await loginMutation.mutateAsync(data);
      setAuthorizationHeader(response?.token);

      const path = await getRedirectPathFromAuth();
      navigate(path);
    } catch (err: any) {
      handleNetworkError(err?.response);
    }
  };
  const handlePartnerLogout = () => {
    logoutMutation.mutateAsync().then(() => {
      authService.refetch();
      localStorage.clear();
    });
  };

  return {
    services: { authService },
    mutations: { loginMutation, logoutMutation },
    functions: { handlePartnerLogin, handlePartnerLogout },
  };
}
